<template>
  <div id="app" ref="app">
    <!--    <keep-alive>-->
    <router-view/>
    <!--    </keep-alive>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {},
  data() {
    return {}
  },
  methods: {
    generateUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
  }
}
</script>

<style>
html,
body,
div,
span,
p,
a,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}


::-webkit-scrollbar {
  width: 0px !important;
  height: 8px;
}

/* 特别为 el-table 设置滚动条样式 */
.el-table__body-wrapper::-webkit-scrollbar {
  width: 12px !important;
  height: 20px !important;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f0f0f0 !important;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #888 !important;
  border-radius: 10px !important;
}

::-webkit-scrollbar-thumb {
  background-color: silver;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.1);
}


</style>
